import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TClearPaymentMethods = IAction<EPaymentActions.CLEAR_METHODS, null>

const clearPaymentMethods = (): TClearPaymentMethods => ({
    type: EPaymentActions.CLEAR_METHODS,
    payload: null,
});

export default clearPaymentMethods;
